import script from "./Reviews.vue?vue&type=script&setup=true&lang=ts"
export * from "./Reviews.vue?vue&type=script&setup=true&lang=ts"

import "./Reviews.vue?vue&type=style&index=0&id=491b7358&scoped=true&lang=scss"

import exportComponent from "/Users/jansavli/Documents/Socutno Zobozdravstvo/socutno-webpage/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-491b7358"]])

export default __exports__